import { createModule, mutation } from "vuex-class-component";

const VuexModule = createModule({
  namespaced: "app",
  strict: false,
  target: "nuxt"
});

export default class AppStore extends VuexModule {
  pageLoaded = false;
  drawer = null;
  fluid = true;
  dark = false;
  fullScreen = false;

  @mutation setPageLoaded() {
    this.pageLoaded = true;

    document.body.removeChild(document.getElementById("loading") as Node);
  }
}
